export const ModalChangePhotoTranslationsEn = {
  addPhoto: 'Add photo',
  textPlaceholder: 'Write your message...',
};
